document.addEventListener("DOMContentLoaded", function () {
  async function favourites() {
    // Function to get the favorite stores from local storage and log them to the console
    const logFavoriteStores = () => {
      console.log('Current Favourite Store:', localStorage.getItem('tg--webcheckin-fav'));
    };

    const allLocations = document.querySelectorAll("li.location");

    allLocations.forEach((location) => {
      // console.log("Location:", location)
      const favIcon = location.querySelector(".fav-location");
      const locationName = location.getAttribute("data-location");

      // Set active if favourite on first load
      const isFav = localStorage.getItem('tg--webcheckin-fav') === locationName;
      if (isFav) document.querySelectorAll(`.location[data-location="${locationName}"]`).forEach(e => e.classList.add("is-fav"));

      // Function to toggle the favorite status
      const toggleFavorite = () => {
        // Recheck Favourite on toggle
        const isFav = localStorage.getItem('tg--webcheckin-fav') === locationName;

        // Remove "is-fav" class from all locations
        document.querySelectorAll('.is-fav').forEach(elem => elem.classList.remove('is-fav'))

        // Toggle Favourite
        if (!isFav) {
          localStorage.setItem('tg--webcheckin-fav', locationName);
          document.querySelectorAll(`.location[data-location="${locationName}"]`).forEach(e => e.classList.add("is-fav"));
        } else {
          localStorage.setItem('tg--webcheckin-fav', undefined);
          document.querySelectorAll(`.location[data-location="${locationName}"]`).forEach(e => e.classList.remove("is-fav"));
        }
      };

      // Add a click event listener to the favorite button
      favIcon.addEventListener("click", () => {
        toggleFavorite();
        logFavoriteStores();
      });
    });

    // Call the function to log favorite stores initially
    logFavoriteStores();
  }
  favourites();
});